import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable,throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { AppConfig } from 'src/app/app.config';
@Injectable({
  providedIn: 'root'
})
export class DepartmentsService {
  departmentSvcUrl : string;
  constructor(private http: HttpClient, private config: AppConfig) {
    this.departmentSvcUrl = this.config.apiUrl + "MasterDataApi";
   
  }
    private handleError(error: HttpErrorResponse) {
      return throwError(error.error);
   }
   headers = new HttpHeaders({
          'Content-Type': 'application/json',
        });
    getDepartments(){
      return this.http.get(this.departmentSvcUrl+"/"+"GetDepartments").pipe(
        catchError(this.handleError)
      );
    }
}

